import React from 'react'

export default function Header() {
  return (
    <h1 className='header' >{"<Sorto-Viz/> "}</h1>
  )
}
